import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const NoDueDepartment = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	const [data, setData] = useState([]);
	const [roledata, setRoleData] = useState([]);
	const [noduedepartmentdata, setNoduedepartmentData] = useState([]);
	// const [item1, setItem]= useState([]);
	const [dataval, setDataVal] = useState([]);
	const [isVisible, setIsVisible] = useState(false);

	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = 1;
	//const handleChange = (e) => setCheckbox(e.target.checked);


	const handleCheckboxChange = (e) => {
		// e.preventDefault();
		const value = e.target.value;


		if (e.target.checked) {
			setSelectedItems([...selectedItems, value]);
		} else {
			setSelectedItems(selectedItems.filter(item => item !== value));
		}
	};


	function checkboxHandler(e) {
		// e.preventDefault();
		let isSelected = e.target.checked;
		let value = parseInt(e.target.value);


        

		if (isSelected) {
			setNoduedepartmentData([...noduedepartmentdata, value]);
		} else {
			setNoduedepartmentData((prevData) => {
				return prevData.filter((department_id) => {
					return department_id != value
				});
			})
		}
	}


	 useEffect(() => {
		  
			axios.get(API_BASE_URL +'/showdepartment/', { headers : {
				   'Content-Type': 'application/json',
				   Authorization: `Bearer ${localStorage.getItem("authToken")}`
		   }})
			.then(res1 => setData(res1.data))
			.catch(err => console.log(err))
		   });









	const handleEditSubmit = (e) => {
  e.preventDefault();

  // Make sure we actually have data
  if (!Array.isArray(noduedepartmentdata) || noduedepartmentdata.length === 0) {
    toast.error("Please select at least one department", {
      position: "bottom-right",
      autoClose: 4000,
      theme: "colored",
    });
    return;
  }

  const payload = {
    nodue_department_id: noduedepartmentdata.join(","), // converts [1,3,5] → "1,3,5"
    setting_id: param,
  };

  axios
    .post(`${API_BASE_URL}/update_nodue_department`, payload, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
    .then((response) => {
      const status = response.data.status;

      if (status === 200) {
        toast.success(response.data.message, {
          position: "bottom-right",
          autoClose: 4000,
          theme: "colored",
        });

        setTimeout(() => {
          history.push(`/Noduedepartment`);
        }, 2000);
      } else {
        toast.error(response.data.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 4000,
          theme: "colored",
        });
      }
    })
    .catch((error) => {
      toast.error(
        error?.response?.data?.message || "Server error occurred",
        {
          position: "bottom-right",
          autoClose: 4000,
          theme: "colored",
        }
      );
    });
};



	// useEffect(() => {
	// 	axios.get(API_BASE_URL + '/fetchmenu', {
	// 		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	// 	})


	// 		.then(res => setData(res.data))
	// 		.catch(err => console.log(err));
	// }, [])


	// useEffect(() => {
	// 	axios.get(API_BASE_URL + '/showroleaccess/' + param, {
	// 		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	// 	})

	// 		//  .then(res1 =>console.log(res1.data))
	// 		.then(res1 => setRoleData(res1.data))
	// 		.catch(err => console.log(err));
	// }, [])

  useEffect(() => {
  axios
    .get(API_BASE_URL + '/noduedepartment/' + param, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
    .then(res => {
      const deptIds = Array.isArray(res.data)
        ? res.data.map(id => parseInt(id))
        : [];
      setNoduedepartmentData(deptIds);
    })
    .catch(err => console.log(err));
}, []);



	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-clipboard mr-2" style={{ fontSize: "20px" }} />
												NoDue Department
											</h3>
										</div>
										<div className="card-body">

											<form onSubmit={handleEditSubmit}>
												{data.map((item, index) => {
													return (
														<div key={index}>
															<div>


																{/* <div>{item1.includes(item.id) ? "checked" : "unchecked"}</div> */}

																<div className="col-md-6 col-sm-6">
																	<div className="form-group">
																		{/* <input type="text" className="form-control" name="sub_menu_name" 
					placeholder="Sub Menu Name" value={item.sub_menu_name}
					onChange={(event) => handleChange(event, index)}/> 
					
					checked={item1.includes(item.id) ? "checked" : ""}*/
																		}
																		<label className="custom-control custom-checkbox custom-control-inline">
																			<input
  type="checkbox"
  className="custom-control-input"
  value={item.department_id}
  checked={noduedepartmentdata.includes(item.department_id)}
  onChange={checkboxHandler}
/>
																			<span className="custom-control-label" style={{ fontSize: '13px' }}>{item.department_name} </span>
																		</label>
																	</div>
																</div>



															</div>


														</div>



													)
												})}

												{/* <div className="body"> {JSON.stringify(users)} </div> */}

												<div class="row">

													{/* <div className="body"> {JSON.stringify(item)} </div>  */}

													<div className="col-md-4 col-sm-6">
														<div className="form-group">

															<button type="submit" className="btn btn-primary">
																Add Nodue Departments
															</button>

															{/* <h2>Result will print here : {roledata.toString()}</h2> */}

														</div>
													</div>


												</div>
											</form>




										</div>
									</div>
								</div>

							</div>
						</div>
					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(NoDueDepartment);